require('./changeEmailController');
require('./changeEmailVerify/changeEmailVerifyController');

angular.module('app.changeEmail', [
  'app.changeEmail.changeEmailController',
  'app.changeEmail.changeEmailVerifyController'
])
  .config([
    '$stateProvider',
    function ($stateProvider) {
      "use strict";

      $stateProvider
        .state('app.changeEmail', {
          url: '/change_email',
          template: '<ui-view></ui-view>',
          controller: [
            '$state', '$stateParams',
            function ($state, $stateParams) {
              if ($state.is('app.changeEmail')) {
                $state.go('app.changeEmail.request', $stateParams);
              }
            }
          ]
        })
        .state('app.changeEmail.request', {
          url: '/request',
          templateUrl: 'components/changeEmail/changeEmailView.html',
          controller: 'app.changeEmail.changeEmailController'
        })
        .state('app.changeEmail.sent', {
          url: '/sent',
          params: {
            email: null
          },
          templateUrl: 'components/changeEmail/changeEmailSent/changeEmailSentView.html',
          controller: [
            '$scope', '$stateParams',
            function ($scope, $stateParams) {
              $scope.email = $stateParams.email;
            }
          ]
        })
        .state('app.changeEmail.verify', {
          url: '/verify/:hash',
          templateUrl: 'components/changeEmail/changeEmailVerify/changeEmailVerifyView.html',
          controller: 'app.changeEmail.changeEmailVerifyController'
        });
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/changeEmail/changeEmail.js